import type { GeneratedLesson } from "../types";
import { Award } from "lucide-react";

interface BNCCSectionProps {
  lesson: GeneratedLesson;
}

export function BNCCSection({ lesson }: BNCCSectionProps) {
  if (!lesson.bnccInfo) {
    return null;
  }

  const hasContent =
    (lesson.bnccInfo.competencias && lesson.bnccInfo.competencias.length > 0) ||
    (lesson.bnccInfo.habilidades && lesson.bnccInfo.habilidades.length > 0) ||
    (lesson.bnccInfo.objetosConhecimento &&
      lesson.bnccInfo.objetosConhecimento.length > 0);

  if (!hasContent) {
    return null;
  }

  return (
    <div className="mb-6">
      <div className="flex items-center gap-2 mb-4">
        <Award className="w-5 h-5" style={{ color: "var(--primary-color)" }} />
        <h3
          className="text-xl font-bold"
          style={{ color: "var(--text-primary)" }}
        >
          Alinhamento BNCC
        </h3>
      </div>

      <div className="space-y-4">
        {lesson.bnccInfo.competencias &&
          lesson.bnccInfo.competencias.length > 0 && (
            <div>
              <h4
                className="font-semibold mb-2"
                style={{ color: "var(--text-primary)" }}
              >
                Competências
              </h4>
              <ul className="space-y-2">
                {lesson.bnccInfo.competencias.map((comp, idx) => (
                  <li
                    key={idx}
                    className="flex items-start gap-2 p-2 rounded-lg"
                    style={{ backgroundColor: "var(--bg-accent)" }}
                  >
                    <span
                      className="shrink-0 w-5 h-5 rounded-full flex items-center justify-center text-xs font-bold"
                      style={{
                        backgroundColor: "var(--primary-color)",
                        color: "white",
                      }}
                    >
                      ✓
                    </span>
                    <span style={{ color: "var(--text-secondary)" }}>
                      {comp}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          )}

        {lesson.bnccInfo.habilidades &&
          lesson.bnccInfo.habilidades.length > 0 && (
            <div>
              <h4
                className="font-semibold mb-2"
                style={{ color: "var(--text-primary)" }}
              >
                Habilidades
              </h4>
              <ul className="space-y-2">
                {lesson.bnccInfo.habilidades.map((hab, idx) => (
                  <li
                    key={idx}
                    className="flex items-start gap-2 p-2 rounded-lg"
                    style={{ backgroundColor: "var(--bg-accent)" }}
                  >
                    <span
                      className="shrink-0 w-5 h-5 rounded-full flex items-center justify-center text-xs font-bold"
                      style={{
                        backgroundColor: "var(--primary-color)",
                        color: "white",
                      }}
                    >
                      ✓
                    </span>
                    <span style={{ color: "var(--text-secondary)" }}>
                      {hab}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          )}

        {lesson.bnccInfo.objetosConhecimento &&
          lesson.bnccInfo.objetosConhecimento.length > 0 && (
            <div>
              <h4
                className="font-semibold mb-2"
                style={{ color: "var(--text-primary)" }}
              >
                Objetos de Conhecimento
              </h4>
              <ul className="space-y-2">
                {lesson.bnccInfo.objetosConhecimento.map((obj, idx) => (
                  <li
                    key={idx}
                    className="flex items-start gap-2 p-2 rounded-lg"
                    style={{ backgroundColor: "var(--bg-accent)" }}
                  >
                    <span
                      className="shrink-0 w-5 h-5 rounded-full flex items-center justify-center text-xs font-bold"
                      style={{
                        backgroundColor: "var(--primary-color)",
                        color: "white",
                      }}
                    >
                      ✓
                    </span>
                    <span style={{ color: "var(--text-secondary)" }}>
                      {obj}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          )}
      </div>
    </div>
  );
}
